export default __webpack_public_path__ + "static/media/selo-30-anos.f8b76d32.webp";